<template>
  <div id="" class="content">
    <div class="content-box">
      <el-tabs v-model="activeName" type="card">
        <el-tab-pane label="等级评分信息" name="levelscore">
          <div>
            <el-form :inline="true" :model="levelScoreForm" class="demo-form-inline" ref="levelScoreForm">
              <el-form-item label="人员ID">
                <el-input v-model="levelScoreForm.personId" placeholder="请输入人员ID" size="small"
                  style="width: 150px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getLevelScoreList" size="small">查询</el-button>
                <el-button type="primary" @click="addLevelScoreInfo" size="small">新增</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="levelScoreTable" style="width: 100%" height="650" border>
              <el-table-column prop="id" label="id"> </el-table-column>
              <el-table-column prop="personId" label="人员ID">
              </el-table-column>
              <el-table-column prop="adLevel" label="成人自由滑"> </el-table-column>
              <el-table-column prop="fsLevel" label="自由滑"> </el-table-column>
              <el-table-column prop="icLevel" label="冰舞"> </el-table-column>
              <el-table-column prop="siLevel" label="步法"> </el-table-column>
              <el-table-column prop="adILevel" label="成人步法"> </el-table-column>

              <el-table-column prop="createTime" label="创建时间" width="180">
              </el-table-column>
              <el-table-column label="可用状态">
                <template slot-scope="scope">
                  {{ scope.row.status == "1" ? "可用" : "不可用" }}
                </template>
              </el-table-column>
              <el-table-column label="删除状态" prop="delFlag">
                <template slot-scope="scope">
                  {{ scope.row.delFlag == "1" ? "未删除" : "已删除" }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="updateLevelScoreInfo(scope.row.id)">修改</el-button>
                  <el-button size="small" type="danger" v-if="scope.row.delFlag == 1"
                    @click="deleteLevelScore(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="报名信息" name="refisteation">
          <div>
            <el-form :inline="true" :model="registrationInfoForm" class="demo-form-inline">
              <el-form-item label="">
                <el-input v-model="registrationInfoForm.personId" placeholder="请输入人员ID" size="small"
                  style="width: 120px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="registrationInfoForm.personName" placeholder="请输入人员姓名" size="small"
                  style="width: 120px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="registrationInfoForm.credentialsNo" placeholder="请输入人员证件号码" size="small"
                  style="width: 150px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="registrationInfoForm.matchId" placeholder="请输入赛事ID" size="small"
                  style="width: 120px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="registrationInfoForm.arragementId" placeholder="请输入分站ID" size="small"
                  style="width: 120px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="registrationInfoForm.description" placeholder="请输入分站名称" size="small"
                  style="width: 150px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-select v-model="registrationInfoForm.payStatus" placeholder="请选择支付状态" size="small"
                  style="width: 150px">
                  <el-option label="已支付" value="Y"></el-option>
                  <el-option label="未支付" value="N"></el-option>
                  <el-option label="支付中" value="P"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getRegistrationInfoList" size="small">查询</el-button>
                <el-button type="primary" @click="exportRegistrationInfo" size="small">数据导出</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="registrationInfoTable" style="width: 100%" height="650" border>
              <el-table-column prop="id" label="id"> </el-table-column>
              <el-table-column prop="personId" label="人员ID">
              </el-table-column>
              <el-table-column prop="personName" label="人员名称">
              </el-table-column>
              <el-table-column label="性别" width="50">
                <template slot-scope="scope">
                  {{ scope.row.gender == "1" ? "男" : "女" }}
                </template>
              </el-table-column>
              <el-table-column label="证件类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.credentialsType == '1'">身份证</span>
                  <span v-else-if="scope.row.credentialsType == '2'">护照</span>
                  <span v-else>户口本</span>
                </template>
              </el-table-column>
              <el-table-column prop="credentialsNo" label="证件号码" width="180">
              </el-table-column>
              <el-table-column prop="orgId" label="组织ID"> </el-table-column>
              <el-table-column prop="orgName" label="组织名称" width="220">
              </el-table-column>
              <el-table-column prop="coachName" label="教练员姓名" width="100">
              </el-table-column>
              <el-table-column prop="coachTel" label="教练员手机号" width="140">
              </el-table-column>
              <el-table-column label="支付状态">
                <template slot-scope="scope">
                  <span v-if="scope.row.payStauts == 'Y'">已支付</span>
                  <span v-else-if="scope.row.payStauts == 'N'">未支付</span>
                  <span v-else>支付中</span>
                </template>
              </el-table-column>
              <el-table-column label="支付金额" prop="cost"> </el-table-column>
              <el-table-column label="赛事ID" prop="matchId" width="70">
              </el-table-column>
              <el-table-column label="赛事名称" prop="matchName">
              </el-table-column>
              <el-table-column label="分站ID" prop="arrangementId" width="70">
              </el-table-column>
              <el-table-column label="分站名称" prop="description" width="170">
              </el-table-column>
              <el-table-column label="成绩" prop="achievement">
              </el-table-column>
              <el-table-column label="评语" prop="comments" width="170">
              </el-table-column>
              <el-table-column label="该级别报考次数" prop="registerCount" width="100">
              </el-table-column>
              <el-table-column prop="createtime" label="创建时间" width="180">
              </el-table-column>
              <el-table-column label="可用状态">
                <template slot-scope="scope">
                  {{ scope.row.status == "1" ? "可用" : "不可用" }}
                </template>
              </el-table-column>
              <el-table-column label="删除状态" prop="delFlag">
                <template slot-scope="scope">
                  {{ scope.row.delFlag == "1" ? "未删除" : "已删除" }}
                </template>
              </el-table-column>
              <el-table-column fixed="right" label="操作" width="150">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="updateRegistrationInfo(scope.row.id)">修改</el-button>
                  <el-button size="small" type="danger" v-if="scope.row.delFlag == 1" @click="
                    deteleRegistrationInfo(scope.row.id, scope.row.personId)
                    ">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="赛事信息" name="match">
          <div>
            <el-form :inline="true" :model="matchForm" class="demo-form-inline" ref="matchForm">
              <el-form-item label="赛事ID">
                <el-input v-model="matchForm.matchId" placeholder="请输入" size="small" style="width: 150px"></el-input>
              </el-form-item>
              <el-form-item label="分站">
                <el-input v-model="matchForm.attribute1" placeholder="请输入" size="small" style="width: 150px"></el-input>
              </el-form-item>
              <el-form-item label="项目">
                <el-input v-model="matchForm.attribute2" placeholder="请输入" size="small" style="width: 150px"></el-input>
              </el-form-item>
              <el-form-item label="等级">
                <el-input v-model="matchForm.attribute3" placeholder="请输入" size="small" style="width: 150px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getMatchList" size="small">查询</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="matchTable" style="width: 100%" height="650" border>
              <el-table-column prop="id" label="id"> </el-table-column>
              <el-table-column prop="matchId" label="赛事ID"> </el-table-column>
              <el-table-column prop="attribute1" label="分站">
              </el-table-column>
              <el-table-column prop="attribute2" label="项目">
              </el-table-column>
              <el-table-column prop="attribute3" label="等级">
              </el-table-column>
              <el-table-column prop="cost" label="金额"> </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180">
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="人员信息" name="person">
          <div>
            <el-form :inline="true" :model="personForm" class="demo-form-inline" ref="levelScoreForm">
              <el-form-item label="">
                <el-input v-model="personForm.accountId" placeholder="请输入账号ID" size="small"
                  style="width: 110px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="personForm.personId" placeholder="请输入人员ID" size="small"
                  style="width: 110px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="personForm.personName" placeholder="请输入人员名称" size="small"
                  style="width: 125px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="personForm.credentialsNo" placeholder="请输入证件号码" size="small"
                  style="width: 130px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-select v-model="personForm.credentialsType" placeholder="请选择证件类型" size="small" style="width: 140px">
                  <el-option label="身份证" value="1"></el-option>
                  <el-option label="护照" value="2"></el-option>
                  <el-option label="户口本" value="3"></el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="personForm.tel" placeholder="请输入电话" size="small" style="width: 120px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getPersonList" size="small">查询</el-button>
                <el-button type="primary" @click="addPersonInfo" size="small">新增</el-button>
                <el-button type="primary" @click="synchronizationFormVisible = true" size="small">同步到花滑</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="personTable" style="width: 100%" height="650" border>
              <el-table-column label="id" prop="id"> </el-table-column>
              <el-table-column label="账户id" prop="accountId">
              </el-table-column>
              <el-table-column label="姓名" prop="name"> </el-table-column>
              <el-table-column label="性别" width="50">
                <template slot-scope="scope">
                  {{ scope.row.sex == "1" ? "男" : "女" }}
                </template>
              </el-table-column>
              <el-table-column label="旧的等级测试ID" prop="oldLvId">
              </el-table-column>
              <el-table-column prop="birthday" label="生日"> </el-table-column>
              <el-table-column prop="nation" label="民族"> </el-table-column>
              <el-table-column prop="fsLevel" label="证件类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.credentialsType == '1'">身份证</span>
                  <span v-else-if="scope.row.credentialsType == '2'">护照</span>
                  <span v-else>户口本</span>
                </template>
              </el-table-column>
              <el-table-column prop="credentialsNo" label="证件号码" width="180">
              </el-table-column>
              <el-table-column prop="address" label="地址"> </el-table-column>
              <el-table-column prop="tel" label="电话"> </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180">
              </el-table-column>
              <el-table-column prop="updateTime" label="修改时间" width="180">
              </el-table-column>
              <el-table-column label="可用状态">
                <template slot-scope="scope">
                  {{ scope.row.status == "1" ? "可用" : "不可用" }}
                </template>
              </el-table-column>
              <el-table-column label="删除状态" prop="delFlag">
                <template slot-scope="scope">
                  {{ scope.row.delFlag == "1" ? "未删除" : "已删除" }}
                </template>
              </el-table-column>
              <el-table-column label="操作" width="150" fixed="right">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="updatePersonInfo(scope.row.id)">修改</el-button>
                  <el-button size="small" type="danger" v-if="scope.row.delFlag == 1"
                    @click="deletePersonInfo(scope.row.id)">删除</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
        <el-tab-pane label="账号信息" name="account">
          <div>
            <el-form :inline="true" :model="accountForm" class="demo-form-inline" ref="levelScoreForm">
              <el-form-item label="">
                <el-input v-model="accountForm.account" placeholder="请输入账号" size="small"
                  style="width: 130px"></el-input>
              </el-form-item>
              <el-form-item label="">
                <el-input v-model="accountForm.accountId" placeholder="请输入账号ID" size="small"
                  style="width: 130px"></el-input>
              </el-form-item>
              <!--<el-form-item label="">-->
              <!--<el-input v-model="accountForm.personId" placeholder="请输入人员ID" size="small" style="width: 130px"></el-input>-->
              <!--</el-form-item>-->
              <!--<el-form-item label="">-->
              <!--<el-input v-model="accountForm.personName" placeholder="请输入人员名称" size="small" style="width: 130px"></el-input>-->
              <!--</el-form-item>-->
              <!--<el-form-item label="">-->
              <!--<el-input v-model="accountForm.credentialsNo" placeholder="请输入证件号码" size="small" style="width: 130px"></el-input>-->
              <!--</el-form-item>-->
              <!--<el-form-item label="">-->
              <!--<el-select v-model="accountForm.credentialsType" placeholder="请选择证件类型" size="small" style="width: 140px">-->
              <!--<el-option label="身份证" value="1"></el-option>-->
              <!--<el-option label="护照" value="2"></el-option>-->
              <!--<el-option label="户口本" value="3"></el-option>-->
              <!--</el-select>-->
              <!--</el-form-item>-->
              <el-form-item label="">
                <el-input v-model="accountForm.tel" placeholder="请输入电话" size="small" style="width: 130px"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="getAccountList" size="small">查询</el-button>
              </el-form-item>
            </el-form>
            <el-table :data="accountTable" style="width: 100%" height="650" border>
              <el-table-column prop="accountId" label="id"> </el-table-column>
              <el-table-column prop="account" label="账号"> </el-table-column>
              <el-table-column prop="tel" label="个人联系电话">
              </el-table-column>
              <el-table-column prop="createTime" label="创建时间" width="180">
              </el-table-column>
              <el-table-column prop="updateTime" label="修改时间" width="180">
              </el-table-column>
              <el-table-column label="操作" width="150">
                <template slot-scope="scope">
                  <el-button size="small" type="primary" @click="modifyAccount(scope.row.accountId)">修改账号密码</el-button>
                  <!--<el-button  size="small" type="danger" v-if="scope.row.delFlag==1" @click="deleteLevelScore(scope.row.id)">删除</el-button>-->
                </template>
              </el-table-column>
            </el-table>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>

    <!--等级测试-->
    <el-dialog :title="updateLevelScoreForm.id != '' ? '修改等级测试' : '添加等级测试'" :visible.sync="levelScoreFormVisible"
      width="968px">
      <el-form :model="updateLevelScoreForm" ref="updateLevelScoreForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="人员ID" label-width="90px" prop="personId">
              <el-input v-model="updateLevelScoreForm.personId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="成人" label-width="90px" prop="adLevel">
              <el-input v-model="updateLevelScoreForm.adLevel" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="自由滑" label-width="90px" prop="fslevel">
              <el-input v-model="updateLevelScoreForm.fsLevel" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="步法" label-width="90px" prop="siLevel">
              <el-input v-model="updateLevelScoreForm.siLevel" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="可用状态" label-width="90px" prop="status">
              <el-select v-model="updateLevelScoreForm.status" placeholder="请选择" style="width: 100%">
                <el-option label="不可用" value="2"></el-option>
                <el-option label="可用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="删除状态" label-width="90px" prop="delFlag">
              <el-select v-model="updateLevelScoreForm.delFlag" placeholder="请选择" style="width: 100%">
                <el-option label="已删除" value="2"></el-option>
                <el-option label="未删除" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="levelScoreFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="levelScoreInfoSubmit('updateLevelScoreForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--修改报名信息-->
    <el-dialog title="修改报名信息" :visible.sync="registrationInfoFormVisible" width="968px">
      <el-form :model="updateRegistrationInfoForm" ref="updateRegistrationInfoForm">
        <el-row>
          <el-col :span="8">
            <el-form-item label="人员名称" label-width="90px" prop="personName">
              <el-input v-model="updateRegistrationInfoForm.personName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="人员ID" label-width="90px" prop="personId">
              <el-input v-model="updateRegistrationInfoForm.personId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="人员性别" label-width="90px" prop="gender">
              <el-select v-model="updateRegistrationInfoForm.gender" placeholder="请选择" style="width: 100%">
                <el-option label="男" value="1"></el-option>
                <el-option label="女" value="2"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件类型" label-width="90px" prop="credentialsType">
              <el-select v-model="updateRegistrationInfoForm.credentialsType" placeholder="请选择" style="width: 100%">
                <el-option label="身份证" value="1"></el-option>
                <el-option label="护照" value="2"></el-option>
                <el-option label="户口本" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="证件号码" label-width="90px" prop="credentialsNo">
              <el-input v-model="updateRegistrationInfoForm.credentialsNo" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>

          <el-col :span="8">
            <el-form-item label="组织ID" label-width="90px" prop="orgId">
              <el-input v-model="updateRegistrationInfoForm.orgId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="组织名称" label-width="90px" prop="orgName">
              <el-input v-model="updateRegistrationInfoForm.orgName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付状态" label-width="90px" prop="payStauts">
              <el-select v-model="updateRegistrationInfoForm.payStauts" placeholder="请选择" style="width: 100%">
                <el-option label="已支付" value="Y"></el-option>
                <el-option label="未支付" value="N"></el-option>
                <el-option label="支付中" value="P"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="支付金额" label-width="90px" prop="cost">
              <el-input v-model="updateRegistrationInfoForm.cost" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛事ID" label-width="90px" prop="matchId">
              <el-input v-model="updateRegistrationInfoForm.matchId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="赛事名称" label-width="90px" prop="matchName">
              <el-input v-model="updateRegistrationInfoForm.matchName" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="分站ID" label-width="90px" prop="arrangementId">
              <el-input v-model="updateRegistrationInfoForm.arrangementId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="成绩" label-width="90px" prop="achievement">
              <el-input v-model="updateRegistrationInfoForm.achievement" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="可用状态" label-width="90px" prop="status">
              <el-select v-model="updateRegistrationInfoForm.status" placeholder="请选择" style="width: 100%">
                <el-option label="不可用" value="2"></el-option>
                <el-option label="可用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="8">
            <el-form-item label="删除状态" label-width="90px" prop="delFlag">
              <el-select v-model="updateRegistrationInfoForm.delFlag" placeholder="请选择" style="width: 100%">
                <el-option label="已删除" value="2"></el-option>
                <el-option label="未删除" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="分站名称" label-width="90px" prop="description">
              <el-input v-model="updateRegistrationInfoForm.description" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="评语" label-width="90px" prop="comments">
              <el-input v-model="updateRegistrationInfoForm.comments" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="registrationInfoFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="registrationInfoSubmit('updateRegistrationInfoForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--人员信息-->
    <el-dialog :title="updatePersonInfoForm.id != '' ? '修改人员信息' : '添加人员信息'" :visible.sync="personInfoFormVisible"
      width="968px">
      <el-form :model="updatePersonInfoForm" ref="updatePersonInfoForm">
        <el-row>
          <el-col :span="12">
            <el-form-item label="人员名称" label-width="120px" prop="name">
              <el-input v-model="updatePersonInfoForm.name" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="账号id" label-width="120px" prop="name">
              <el-input v-model="updatePersonInfoForm.accountId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="出生日期" label-width="120px" prop="birthday">
              <el-date-picker v-model="updatePersonInfoForm.birthday" type="date" placeholder="选择日期"
                style="width: 100%">
              </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系地址" label-width="120px" prop="address">
              <el-input v-model="updatePersonInfoForm.address" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="国籍" label-width="120px" prop="nation">
              <el-input v-model="updatePersonInfoForm.nation" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件类型" label-width="120px" prop="credentialsType">
              <el-select v-model="updatePersonInfoForm.credentialsType" placeholder="请选择" style="width: 100%">
                <el-option label="身份证" value="1"></el-option>
                <el-option label="护照" value="2"></el-option>
                <el-option label="户口本" value="3"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="证件号码" label-width="120px" prop="credentialsNo">
              <el-input v-model="updatePersonInfoForm.credentialsNo" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="旧的等级测试ID" label-width="120px" prop="oldLvId">
              <el-input v-model="updatePersonInfoForm.oldLvId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="性别" label-width="120px" prop="sex">
              <el-select v-model="updatePersonInfoForm.sex" placeholder="请选择" style="width: 100%">
                <el-option label="女" value="2"></el-option>
                <el-option label="男" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="联系电话" label-width="120px" prop="tel">
              <el-input v-model="updatePersonInfoForm.tel" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="updatePersonInfoForm.id != ''">
            <el-form-item label="可用状态" label-width="120px" prop="status">
              <el-select v-model="updatePersonInfoForm.status" placeholder="请选择" style="width: 100%">
                <el-option label="不可用" value="2"></el-option>
                <el-option label="可用" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12" v-if="updatePersonInfoForm.id != ''">
            <el-form-item label="删除状态" label-width="120px" prop="delFlag">
              <el-select v-model="updatePersonInfoForm.delFlag" placeholder="请选择" style="width: 100%">
                <el-option label="已删除" value="2"></el-option>
                <el-option label="未删除" value="1"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="personInfoFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="personInfoSubmit('updatePersonInfoForm')">确 定</el-button>
      </div>
    </el-dialog>
    <!--同步到花滑-->
    <el-dialog title="同步到花滑" :visible.sync="synchronizationFormVisible" width="968px">
      <el-form :model="synchronizationInfoForm" ref="synchronizationInfoForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="人员ID" label-width="90px" prop="personId">
              <el-input v-model="synchronizationInfoForm.personId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="赛事ID" label-width="90px" prop="matchId">
              <el-input v-model="synchronizationInfoForm.matchId" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="证书名称" label-width="90px" prop="competitionName">
              <el-input v-model="synchronizationInfoForm.competitionName" placeholder="如:2019-2020第一次国家花样滑冰等级测试"
                autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="synchronizationFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="synchronization">确 定</el-button>
      </div>
    </el-dialog>

    <!--修改账号密码-->
    <el-dialog title="修改账号密码" :visible.sync="accountFormVisible" width="450px">
      <el-form :model="updateAccountInfoForm" ref="updateAccountInfoForm">
        <el-row>
          <el-col :span="24">
            <el-form-item label="账号ID" label-width="90px" prop="id">
              <el-input v-model="updateAccountInfoForm.id" autocomplete="off" readonly></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="24">
            <el-form-item label="账号密码" label-width="90px" prop="passsword">
              <el-input v-model="updateAccountInfoForm.passsword" autocomplete="off"></el-input>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="accountFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="accountInfoSubmit('updateAccountInfoForm')">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import axios from "axios";
import { get, post } from "@/api/fetch.js";
import url from "@/api/serviceAPI.config.js";
import blue from "@/assets/images/blue.png";
import yello from "@/assets/images/yello.png";
export default {
  name: "",
  data() {
    return {
      activeName: "levelscore",
      token: sessionStorage.getItem("ACCESS_TOKEN"),
      levelScoreForm: {
        personId: "", //人员ID8106
      },
      registrationInfoForm: {
        personId: "29495", //人员ID
        personName: "", //人员姓名
        credentialsNo: "", //人员证件号码
        matchId: "", //赛事Id
        arragementId: "", //分站Id
        description: "", //分站名称
        payStatus: "", //支付状态(Y-已支付,N-未支付,P-支付中)
      },
      matchForm: {
        matchId: "", //赛季id
        attribute1: "", //分站
        attribute2: "", //项目
        attribute3: "", //等级
      },
      personForm: {
        account: "",
        orgId: "",
        accountId: "",
        personId: "8108",
        personName: "",
        credentialsNo: "",
        credentialsType: "",
        tel: "",
        competitionName: "",
      },
      synchronizationInfoForm: {
        competitionName: "",
        matchId: "",
        personId: "",
      },
      accountForm: {
        account: "",
        accountId: "",
        personId: "",
        personName: "",
        credentialsNo: "",
        credentialsType: "",
        tel: "",
      },
      updateRegistrationInfoForm: {
        achievement: "",
        arrangementId: "",
        comments: "",
        cost: "",
        createId: "",
        credentialsNo: "	",
        credentialsType: "",
        delFlag: "",
        description: "",
        gender: "",
        id: "",
        matchId: "",
        matchName: "",
        orgId: "",
        orgName: "",
        payStauts: "",
        personId: "",
        personName: "",
        status: "1",
        tenantCode: "",
        updateId: "",
      },
      updatePersonInfoForm: {
        id: "",
        accountId: "",
        name: "",
        birthday: "",
        address: "",
        nation: "",
        credentialsNo: "",
        credentialsType: "",
        oldLvId: "",
        sex: "",
        tel: "",
        delFlag: "",
        status: "",
      },
      updateLevelScoreForm: {
        adLevel: "",
        createTime: "",
        delFlag: "",
        fsLevel: "",
        id: "",
        personId: "",
        siLevel: "",
        status: "",
        updateTime: "",
      },
      updateAccountInfoForm: {
        id: "",
        passsword: "",
      },
      levelScoreTable: [],
      registrationInfoTable: [],
      matchTable: [],
      personTable: [],
      accountTable: [],
      registrationInfoFormVisible: false,
      personInfoFormVisible: false,
      levelScoreFormVisible: false,
      accountFormVisible: false,
      synchronizationFormVisible: false,
    };
  },
  methods: {
    // 等级评分列表
    getLevelScoreList() {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] =
        "application/json;charset=UTF-8";
      instance.defaults.headers.token = this.token;
      instance.post(url.searchLevelScore, this.levelScoreForm).then((res) => {
        if (res.data.status == 200) {
          this.levelScoreTable = res.data.data;
        } else {
          this.$message.error(res.data.message);
          if (res.data.status == 401) this.$router.push("/login");
          this.registrationInfoTable = res.data.data;
        }
      });
    },
    deleteLevelScore(id) {
      let pm = "id:" + id;
      this.$alert("是否删除该数据", "删除", {
        confirmButtonText: "确定",
        callback: (action) => {
          // 创建实例时设置配置的默认值
          var instance = axios.create();
          // 在实例已创建后修改默认值
          instance.defaults.headers.post["Content-Type"] = "application/json";
          instance.defaults.headers.token = this.token;
          instance.post(url.deleteLevelScore + "?id=" + id, pm).then((res) => {
            if (res.data.status == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getLevelScoreList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        },
      });
    },
    findLevelScoreVo(id) {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      instance.defaults.headers.token = this.token
      instance.get(url.findLevelScoreVo + "?id=" + id).then((res) => {
        if (res.data.status == 200) {
          this.updateLevelScoreForm = res.data.data;
          this.updateLevelScoreForm.status =
            this.updateLevelScoreForm.status + "";
          this.updateLevelScoreForm.delFlag =
            this.updateLevelScoreForm.delFlag + "";
          console.log(typeof this.updateLevelScoreForm.delFlag);
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    updateLevelScoreInfo(id) {
      let uid = id;
      this.findLevelScoreVo(uid);
      this.levelScoreFormVisible = true;
    },
    addLevelScoreInfo() {
      (this.updateLevelScoreForm = {
        adLevel: "",
        createTime: "",
        delFlag: "",
        fsLevel: "",
        id: "",
        personId: "",
        siLevel: "",
        status: "",
        updateTime: "",
      }),
        (this.levelScoreFormVisible = true);
    },
    levelScoreInfoSubmit(formName) {
      // updateRegistrationInfo
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.updateLevelScoreForm.id) {
            // 创建实例时设置配置的默认值
            var instance = axios.create();
            // 在实例已创建后修改默认值
            instance.defaults.headers.post["Content-Type"] = "application/json";
            instance.defaults.headers.token = this.token
            instance.post(url.updateLevelScore, this.updateLevelScoreForm)
              .then((res) => {
                if (res.data.status == 200) {
                  this.$message({
                    message: "修改成功",
                    type: "success",
                  });
                  this.levelScoreFormVisible = false;
                  this.getLevelScoreList();
                  this.$refs[formName].resetFields();
                } else {
                  console.log("操作失败");
                  this.$message.error(res.data.message);
                }
              });
          } else {
            // 创建实例时设置配置的默认值
            var instance = axios.create();
            // 在实例已创建后修改默认值
            instance.defaults.headers.post["Content-Type"] = "application/json";
            instance.defaults.headers.token = this.token
            instance.post(url.putLevelScore, this.updateLevelScoreForm)
              .then((res) => {
                if (res.data.status == 200) {
                  this.$message({
                    message: "添加成功",
                    type: "success",
                  });
                  this.levelScoreFormVisible = false;
                  this.$refs[formName].resetFields();
                } else {
                  console.log("操作失败");
                  this.$message.error(res.data.message);
                }
              });
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 报名信息
    getRegistrationInfoList() {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      if (this.token) instance.defaults.headers.token = this.token;
      instance.post(url.searchRegistrationInfo, this.registrationInfoForm)
        .then((res) => {
          if (res.data.status == 200) {
            this.registrationInfoTable = res.data.data;
          } else {
            console.log("操作失败");
            this.$message.error(res.data.message);
            if (res.data.status == 401) this.$router.push("/login");
            this.registrationInfoTable = res.data.data;
          }
        });
    },
    deteleRegistrationInfo(id, personId) {
      let pm = "id:" + id;
      this.$alert("是否删除该数据", "删除", {
        confirmButtonText: "确定",
        callback: (action) => {
          // 创建实例时设置配置的默认值
          var instance = axios.create();
          // 在实例已创建后修改默认值
          instance.defaults.headers.post["Content-Type"] = "application/json";
          instance.defaults.headers.token = this.token
          instance.post(url.deleteRegistration + "?id=" + id, pm)
            .then((res) => {
              if (res.data.status == 200) {
                this.$message({
                  message: res.data.message,
                  type: "success",
                });
                this.registrationInfoForm = {
                  personId: personId, //人员ID
                  personName: "", //人员姓名
                  credentialsNo: "", //人员证件号码
                  matchId: "", //赛事Id
                  arragementId: "", //分站Id
                  payStatus: "", //支付状态(Y-已支付,N-未支付,P-支付中)
                };
                this.getRegistrationInfoList();
              } else {
                this.$message.error(res.data.message);
              }
            });
        },
      });
    },
    exportRegistrationInfo() {
      if (this.registrationInfoForm.description == "") {
        this.$message.error("分站名称不能为空");
      } else if (this.registrationInfoForm.matchId == "") {
        this.$message.error("赛事Id不能为空");
      } else if (this.registrationInfoForm.payStatus == "") {
        this.$message.error("请选择支付状态");
      } else {
        // 创建实例时设置配置的默认值
        var instance = axios.create();
        // 在实例已创建后修改默认值
        instance.defaults.headers.post["Content-Type"] =
          "application/octet-stream";
        if (this.token) instance.defaults.headers.token = this.token;
        instance({
          method: "post",
          url: url.exportRegistrationInfo,
          data: this.registrationInfoForm,
          responseType: "blob",
        }).then((res) => {
          const link = document.createElement("a");
          let blob = new Blob([res.data], { type: "application/vnd.ms-excel" });
          link.style.display = "none";
          link.href = URL.createObjectURL(blob);
          // link.download = res.headers['content-disposition'] //下载后文件名
          link.download = "报名信息表"; //下载的文件名
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
        });
      }
    },
    findRegistration(id) {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      instance.defaults.headers.token = this.token;
      instance.get(url.findRegistration + "?id=" + id).then((res) => {
        if (res.data.status == 200) {
          this.updateRegistrationInfoForm = res.data.data[0];
          delete this.updateRegistrationInfoForm.createTime;
          delete this.updateRegistrationInfoForm.remainingTime;
          delete this.updateRegistrationInfoForm.updateTime;
          delete this.updateRegistrationInfoForm.createId;
          delete this.updateRegistrationInfoForm.tenantCode;
          delete this.updateRegistrationInfoForm.updateId;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    updateRegistrationInfo(id) {
      let uid = id;
      this.findRegistration(uid);
      this.registrationInfoFormVisible = true;
    },
    registrationInfoSubmit(formName) {
      // updateRegistrationInfo
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 创建实例时设置配置的默认值
          var instance = axios.create();
          // 在实例已创建后修改默认值
          instance.defaults.headers.post["Content-Type"] = "application/json";
          instance.defaults.headers.token = this.token;
          instance.post(url.updateRegistrationInfo, this.updateRegistrationInfoForm)
            .then((res) => {
              if (res.data.status == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.registrationInfoFormVisible = false;
                this.getRegistrationInfoList();
                this.$refs[formName].resetFields();
              } else {
                console.log("操作失败");
                this.$message.error(res.data.message);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    //赛事
    getMatchList() {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      instance.defaults.headers.token = this.token;
      instance.post(url.findMatchByConditions, this.matchForm).then((res) => {
        console.log(res);
        if (res.data.status == 200) {
          this.matchTable = res.data.data;
        } else {
          console.log("操作失败");
          this.$message.error(res.data.message);
        }
      });
    },
    //人员
    getPersonList() {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      instance.defaults.headers.token = this.token;
      instance.post(url.searchPerson, this.personForm).then((res) => {
        console.log(res);
        if (res.data.status == 200) {
          this.personTable = res.data.data;
        } else {
          console.log("操作失败");
          this.$message.error(res.data.message);
        }
      });
    },
    findPersonInfo(id) {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      instance.defaults.headers.token = this.token;
      instance.get(url.findPersonInfo + "?id=" + id).then((res) => {
        if (res.data.status == 200) {
          console.log(res);
          this.updatePersonInfoForm = res.data.data;
        } else {
          this.$message.error(res.data.message);
        }
      });
    },
    updatePersonInfo(id) {
      let uid = id;
      this.findPersonInfo(uid);
      this.personInfoFormVisible = true;
    },
    addPersonInfo() {
      this.updatePersonInfoForm = {
        id: "",
        accountId: "",
        name: "",
        birthday: "",
        address: "",
        nation: "",
        credentialsNo: "",
        credentialsType: "",
        oldLvId: "",
        sex: "",
        tel: "",
        delFlag: "",
        status: "",
      };
      this.personInfoFormVisible = true;
    },
    personInfoSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.updatePersonInfoForm.id) {
            console.log(this.updatePersonInfoForm);
            this.modifyPersonInfo();
          } else {
            this.addPersonInfofun();
          }
          // this.$refs[formName].resetFields();
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    modifyPersonInfo() {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      instance.defaults.headers.token = this.token;
      instance.post(url.updatePersonInfo, this.updatePersonInfoForm)
        .then((res) => {
          if (res.data.status == 200) {
            this.$message({
              message: "修改成功",
              type: "success",
            });
            this.personInfoFormVisible = false;
            this.getPersonList();
          } else {
            console.log("操作失败");
            this.$message.error(res.data.message);
          }
        });
    },
    addPersonInfofun() {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      instance.defaults.headers.token = this.token;
      instance.post(url.addPersonInfo, this.updatePersonInfoForm)
        .then((res) => {
          if (res.data.status == 200) {
            this.$message({
              message: "操作成功",
              type: "success",
            });
            this.personInfoFormVisible = false;
          } else {
            console.log("操作失败");
            this.$message.error(res.data.message);
          }
        });
    },
    deletePersonInfo(id) {
      let pm = "id:" + id;
      this.$alert("是否删除该数据", "删除", {
        confirmButtonText: "确定",
        callback: (action) => {
          // 创建实例时设置配置的默认值
          var instance = axios.create();
          // 在实例已创建后修改默认值
          instance.defaults.headers.post["Content-Type"] = "application/json";
          instance.defaults.headers.token = this.token;
          instance.post(url.deletePersonInfo + "?id=" + id, pm).then((res) => {
            if (res.data.status == 200) {
              this.$message({
                message: "删除成功",
                type: "success",
              });
              this.getPersonList();
            } else {
              this.$message.error(res.data.message);
            }
          });
        },
      });
    },
    synchronization() {
      //同步花滑
      if (this.synchronizationInfoForm.competitionName == "") {
        this.$message.error("请输入证件名称");
      } else if (this.synchronizationInfoForm.matchId == "") {
        this.$message.error("请输入赛事ID");
      } else if (this.synchronizationInfoForm.personId == "") {
        this.$message.error("请输入人员ID");
      } else {
        // 创建实例时设置配置的默认值
        var instance = axios.create();
        // 在实例已创建后修改默认值
        instance.defaults.headers.post["Content-Type"] = "application/json";
        instance.defaults.headers.token = this.token;
        instance.post(url.updateScoreToCfsa, this.synchronizationInfoForm)
          .then((res) => {
            if (res.status == "200") {
              this.$message({
                message: "操作成功",
                type: "success",
              });
              this.synchronizationFormVisible = false;
            } else {
              this.$message.err("操作失败");
            }
          });
      }
    },
    //账号
    getAccountList() {
      // 创建实例时设置配置的默认值
      var instance = axios.create();
      // 在实例已创建后修改默认值
      instance.defaults.headers.post["Content-Type"] = "application/json";
      instance.defaults.headers.token = this.token;
      instance.post(url.searchAccount, this.accountForm).then((res) => {
        if (res.data.status == 200) {
          this.accountTable = res.data.data;
        } else {
          console.log("操作失败");
          this.$message.error(res.data.message);
        }
      });
    },
    modifyAccount(id) {
      this.updateAccountInfoForm.id = id;
      this.accountFormVisible = true;
    },
    accountInfoSubmit(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // 创建实例时设置配置的默认值
          var instance = axios.create();
          // 在实例已创建后修改默认值
          instance.defaults.headers.post["Content-Type"] = "application/json";
          instance.defaults.headers.token = this.token;
          instance.post(
            url.updatePassword +
            "?id=" +
            this.updateAccountInfoForm.id +
            "&password=" +
            this.updateAccountInfoForm.passsword
          )
            .then((res) => {
              if (res.data.status == 200) {
                this.$message({
                  message: "修改成功",
                  type: "success",
                });
                this.$refs[formName].resetFields();
              } else {
                console.log("操作失败");
                this.$message.error(res.data.message);
              }
            });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
  created() {
    this.getLevelScoreList();
    this.getRegistrationInfoList();
    this.getMatchList();
    this.getPersonList();
    this.getAccountList();
  },
  watch: {},
};
</script>

<style type="text/scss" lang="scss" scoped>
.content {
  width: 100%;

  .content-box {
    width: 1200px;
    margin: 0 auto;
    margin-top: 20px;

    .left-item-box {
      width: 200px;
      margin-right: 10px;
      border: 1px solid #dddddd;
      float: left;

      .totle-title {
        height: 32px;
        line-height: 32px;
        padding-left: 10px;
        background-image: linear-gradient(to top, #ff6102, #ff873f);
        color: #ffffff;
        font-size: 14px;
      }
    }

    .right-content-box {
      width: 988px;
      float: right;
    }

    .two_title {
      font-size: 12px;
      color: #333333;
      padding-left: 20px;
      border-bottom: 1px solid #dddddd;
      border-top: 1px solid #dddddd;
      height: 30px;
      line-height: 30px;
      background-image: linear-gradient(to top, #fcfbfc, #fbfbfb);
    }

    .link {
      font-size: 12px;
      color: #767676;
      padding-left: 0px;
      height: 30px;
      line-height: 30px;
    }

    .icon-jiantou {
      margin-left: 36px;
      font-size: 12px;
      color: #4ca6c1;
    }

    .active {
      .icon-jiantou {
        float: right;
        margin: 10px 10px;
        color: #ff873f;
      }

      .link {
        margin-left: 42px;
      }
    }
  }
}

.active {
  background: #f5f5f5;
  border-left: 2px solid #ff873f;
  margin-left: -1px;
}
</style>



// WEBPACK FOOTER //
// src/components/pages/rootPage/levelScore.vue